import { Idea, MediaType, PostMediaValidity } from '~/content/types';

export const hasMultipleVideos = (idea: Idea): boolean => {
  let videoCount = 0;
  idea.content.media?.forEach((media) => {
    if (media.type === MediaType.video) {
      videoCount += 1;
    }
  });
  return videoCount > 1;
};

export const hasMixedMediaTypes = (idea: Idea): boolean => {
  let hasMixedMedia = false;
  let lastMediaType: MediaType | null = null;
  idea.content.media?.forEach((media) => {
    if (lastMediaType && media.type !== lastMediaType) {
      hasMixedMedia = true;
      return;
    }
    lastMediaType = media.type;
  });
  return hasMixedMedia;
};

export const isMediaConvertibleToPost = (idea: Idea): PostMediaValidity => {
  if (hasMultipleVideos(idea)) {
    return {
      valid: false,
      message: 'Multiple videos not supported',
    };
  }

  if (hasMixedMediaTypes(idea)) {
    return {
      valid: false,
      message: 'Different media types not supported',
    };
  }
  return {
    valid: true,
    message: null,
  };
};
